import * as React from "react";
import { Route, Navigate } from "react-router-dom";
import { SwitchWith404 } from "Config/Router";
import { QAListPage } from "./Pages/QAListPage";
import { qaCategoriesStore } from "./Stores/QACategoriesStore";
import { QADetails } from "./Pages/QADetails";
import { projectsDataStore } from "Stores/ProjectsStore";
import { QA_LINK } from "./enums";
import { ModalConsumer } from "Components/General/Modal/ModalContext";
import { qaUnreadStore } from "./Stores/QAUnreadStore";

// used to have the only fetch interval between fetching unread qa
export const FETCH_INTERVAL = 65000;

interface QAState {
  redirectUrl: string;
}
export class QA extends React.Component<{}, QAState> {
  private unreadFetchInterval: number;
  private redirectUrl: string;

  constructor(props: {}) {
    super(props);
    this.setRedirectUrl();
  }

  componentDidMount() {
    qaCategoriesStore.fetch();
    (async () => {
      await qaUnreadStore.fetch();
    })();
    this.unreadFetchInterval = window.setInterval(() => qaUnreadStore.fetch(), FETCH_INTERVAL);
  }

  componentWillUnmount() {
    clearInterval(this.unreadFetchInterval);
  }

  setRedirectUrl() {
    const { qaModuleSettings = {} } = projectsDataStore.currentProject;
    let url = ``;
    if (qaModuleSettings.questioner) {
      url += QA_LINK.QUESTIONS;
    } else if (qaModuleSettings.bidderGatekeeper) {
      url += QA_LINK.ADMISSION;
    } else if (qaModuleSettings.generalGatekeeper) {
      url += QA_LINK.ACCEPT;
    } else if (qaModuleSettings.specialist || qaModuleSettings.delegatedTo) {
      url += QA_LINK.ANSWER;
    } else if (qaModuleSettings.categoryApproval) {
      url += QA_LINK.CAT_APPROVE;
    } else if (qaModuleSettings.approvalStage_1) {
      url += QA_LINK.APPROVE_1;
    } else if (qaModuleSettings.approvalStage_2) {
      url += QA_LINK.APPROVE_2;
    } else if (qaModuleSettings.readAll) {
      url += QA_LINK.ALL_QUESTIONS;
    } else {
      // if no match - just use first option =)
      url += QA_LINK.QUESTIONS;
    }
    this.redirectUrl = url;
  }

  render() {
    return (
      <ModalConsumer>
        {({ showModal }) => (
          <SwitchWith404>
            <Route path="*" element={<Navigate to={this.redirectUrl} replace />} />
            <Route path={`${QA_LINK.ALL_QUESTIONS}`} element={<QAListPage qaType="READ_ALL" />} />
            {(projectsDataStore.currentProject.qaModuleSettings?.specialist ||
              projectsDataStore.currentProject.qaModuleSettings?.delegatedTo) && (
              <Route path={`${QA_LINK.ANSWER}`} element={<QAListPage qaType="SPECIALIST" />} />
            )}
            <Route path={`${QA_LINK.QUESTIONS}`} element={<QAListPage qaType="BUYER" />} />
            <Route path={`${QA_LINK.ADMISSION}`} element={<QAListPage qaType="GATEKEEPER_BUYER" />} />
            <Route path={`${QA_LINK.ACCEPT}`} element={<QAListPage qaType="GATEKEEPER_SELLER" />} />
            <Route path={`${QA_LINK.CAT_APPROVE}`} element={<QAListPage qaType="APPROVAL_CATEGORY" />} />
            <Route path={`${QA_LINK.APPROVE_1}`} element={<QAListPage qaType="APPROVAL_FIRST_STAGE" />} />
            <Route path={`${QA_LINK.APPROVE_2}`} element={<QAListPage qaType="APPROVAL_SECOND_STAGE" />} />
            <Route path={`:filter/qa-search-results`} element={<QAListPage qaType="SEARCH" />} />
            <Route path={`:filter/:id`} element={<QADetails showModal={showModal} />} />
          </SwitchWith404>
        )}
      </ModalConsumer>
    );
  }
}
